<template>
  <div>
    <!-- Toolbar -->
    <v-app-bar color="red" dark outlined app>
      <v-btn icon @click="$router.go(-1)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
      <v-toolbar-title>Staff</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon dark @click="isShowAddStaff = true">
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main>
      <!-- Skeleton -->
      <div v-if="isLoading">
        <v-skeleton-loader
          class="mx-auto"
          type="list-item-two-line"
          v-for="i in 3"
          :key="i"
        ></v-skeleton-loader>
      </div>

      <!-- Staff list -->
      <v-list flat v-else>
        <v-list-item
          v-for="staff in staffList"
          :key="staff.id"
          two-line
          @click="showBlockStaff(staff.id)"
        >
          <v-list-item-content>
            <v-list-item-title>{{ staff.name }}</v-list-item-title>
            <v-list-item-subtitle>Status: Aktif</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
        <v-divider></v-divider>
      </v-list>

      <!-- Delete staff dialog -->
      <v-dialog v-model="blockDialog" persistent>
        <v-card>
          <v-card-text class="text-h6 text-center"
            >Apakah anda yakin ingin memblokir staff ini?</v-card-text
          >
          <v-card-actions>
            <v-btn color="red" dark @click="blockStaff">Ya</v-btn>
            <v-spacer></v-spacer>
            <v-btn color="black" dark @click="blockDialog = false">Tidak</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Edit menu dialog -->
      <v-dialog
        v-model="isShowAddStaff"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="red">
            <v-toolbar-title>Tambah Staff Baru</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn icon dark @click="isShowAddStaff = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-title class="align-center"></v-card-title>
          <v-card-text>
            <v-form v-model="valid" ref="form">
              <v-text-field
                v-model="newStaff.name"
                label="Nama Staff"
                type="text"
                :rules="rules.required"
                required
              ></v-text-field>
              <v-text-field
                v-model="newStaff.username"
                label="Username Staff"
                type="text"
                :rules="rules.username"
                required
              ></v-text-field>
              <v-text-field
                v-model="newStaff.email"
                label="Email Staff"
                type="text"
                :rules="rules.email"
                required
              ></v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions class="pa-2 mx-2">
            <v-btn
              color="red"
              :dark="valid"
              block
              :disabled="!valid"
              @click="addStaff"
              >Tambah</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Overlay -->
      <v-overlay :value="showOverlay" z-index="9999">
        <v-progress-circular indeterminate size="64"></v-progress-circular>
      </v-overlay>

      <!-- Snackbar -->
      <v-snackbar v-model="showSnackbar" multi-line bottom>{{
        textSnackbar
      }}</v-snackbar>
    </v-main>
  </div>
</template>

<script>
import EzKasirAPI from "@/library/api";
import store from "@/store";

export default {
  name: "Staff",
  data() {
    return {
      storeId: this.$route.params.id,
      user: {},
      staffList: [],
      newStaff: {},
      isLoading: true,
      blockStaffId: "",
      blockDialog: false,
      showOverlay: false,
      showSnackbar: false,
      textSnackbar: "",
      isShowAddStaff: false,
      valid: false,
      rules: {
        required: [(v) => !!v || "Nama wajib diisi"],
        email: [
          (v) => !!v || "email wajib diisi",
          (v) => /.+@.+\..+/.test(v) || "E-mail tidak valid",
        ],
        username: [
          (v) => !!v || "Username wajib diisi",
          (v) => (!!v && v.length <= 25) || "Username maksimum 25 karakter",
          (v) => {
            const pattern = /^[a-zA-Z0-9]+$/;
            return (
              pattern.test(v) ||
              "Username tidak boleh mengandung spesial karakter"
            );
          },
        ],
      },
    };
  },
  methods: {
    loadStaff() {
      const url = `${process.env.VUE_APP_API_URL}/store/staff/${this.storeId}`;
      EzKasirAPI.get(url)
        .then((response) => {
          this.staffList = response.data.data;
        })
        .catch((error) => {
          console.error(error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    addStaff() {
      this.showOverlay = true;

      const url = `${process.env.VUE_APP_API_URL}/store/staff/${this.storeId}`;
      EzKasirAPI.post(url, this.newStaff)
        .then(() => {
          this.textSnackbar = "Berhasil menambah staff.";
        })
        .catch((error) => {
          console.error(error);
          this.textSnackbar = "Gagal menambah staff.";
        })
        .finally(() => {
          this.dissmissReload();
        });
    },
    blockStaff() {
      this.showOverlay = true;

      const url = `${process.env.VUE_APP_API_URL}/store/staff/block/${this.blockStaffId}`;
      EzKasirAPI.delete(url)
        .then(() => {
          this.textSnackbar = "Berhasil memblokir staff.";
        })
        .catch((error) => {
          console.error(error);
          this.textSnackbar = "Gagal memblokir staff.";
        })
        .finally(() => {
          this.dissmissReload();
        });
    },
    showBlockStaff(id) {
      this.blockStaffId = id;
      this.blockDialog = true;
    },
    dissmissReload() {
      this.showSnackbar = true;
      this.showOverlay = false;
      this.blockDialog = false;
      this.isShowAddStaff = false;
      this.loadStaff();
    },
  },
  created() {
    this.user = store.state.user;
    this.loadStaff();
  },
  watch: {
    isShowAddStaff() {
      this.newStaff = {};
      this.valid = false;
      this.$refs.form.resetValidation();
    },
  },
};
</script>